import React from 'react';

const Services = () => {
  const handleCTAClick = (label) => {
    try {
      if (window.gtag) {
        window.gtag('event', 'cta_click', { label });
      }
    } catch (e) { }
  };

  const services = [
    {
      id: 6,
      category: 'ai',
      icon: 'fas fa-robot',
      title: 'AI Integrations',
      description: 'Intelligent features powered by OpenAI, custom ML models, and advanced analytics.',
      features: ['GPT-4 Integration', 'Custom ML Models', 'Data Analytics', 'AI Chatbots'],
      complexity: 'Advanced',
      timeline: '',
      highlighted: true
    },
    {
      id: 3,
      category: 'development',
      icon: 'fas fa-code',
      title: 'Full-Stack Web Apps',
      description: 'Modern, responsive web applications built with cutting-edge technologies and best practices.',
      features: ['React/Next.js Frontend', 'Node.js/Python Backend', 'Database Design', 'API Development'],
      complexity: 'Intermediate',
      timeline: '',
      highlighted: true
    },
    {
      id: 1,
      category: 'blockchain',
      icon: 'fas fa-cubes',
      title: 'Blockchain dApps',
      description: 'Build secure, scalable decentralized applications with smart contracts and DeFi protocols.',
      features: ['Smart Contract Development', 'DeFi Protocols', 'NFT Marketplaces', 'Wallet Integration'],
      complexity: 'Advanced',
      timeline: '',
      highlighted: true
    },
    {
      id: 8,
      category: 'ai',
      icon: 'fas fa-cogs',
      title: 'Automation & Workflows',
      description: 'Streamline business processes with intelligent automation and workflow optimization.',
      features: ['Process Automation', 'Zapier/Make Integration', 'Data Processing', 'Reporting Systems'],
      complexity: 'Intermediate',
      timeline: '',
      highlighted: false
    },
    {
      id: 5,
      category: 'development',
      icon: 'fas fa-server',
      title: 'Backend Systems',
      description: 'Robust backend infrastructure with microservices architecture and cloud deployment.',
      features: ['Microservices', 'Cloud Infrastructure', 'Database Optimization', 'API Management'],
      complexity: 'Advanced',
      timeline: '',
      highlighted: false
    },
    {
      id: 4,
      category: 'development',
      icon: 'fas fa-desktop',
      title: 'Progressive Web Apps',
      description: 'Fast, reliable web applications that work across all devices with app-like experience.',
      features: ['PWA Technology', 'Offline Functionality', 'Push Notifications', 'App-like Experience'],
      complexity: 'Intermediate',
      timeline: '',
      highlighted: false
    },
    {
      id: 2,
      category: 'blockchain',
      icon: 'fas fa-shield-alt',
      title: 'Security & Audits',
      description: 'Comprehensive security reviews and audits for blockchain applications and smart contracts.',
      features: ['Smart Contract Audits', 'Penetration Testing', 'Security Best Practices', 'Compliance'],
      complexity: 'Expert',
      timeline: '',
      highlighted: false
    },
    {
      id: 7,
      category: 'ai',
      icon: 'fas fa-plug',
      title: 'API & Integrations',
      description: 'Seamless integration with third-party services and custom API development.',
      features: ['REST/GraphQL APIs', 'Payment Gateways', 'CRM Integration', 'Webhook Systems'],
      complexity: 'Intermediate',
      timeline: '',
      highlighted: false
    }
  ];

  return (
    <section id="services" className="section services-section">
      <div className="container">
        <div className="section-head">
          <div className="section-badge">
            <i className="fas fa-cogs"></i>
            <span>Services</span>
          </div>
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">
            End-to-end engineering solutions to launch and scale your digital products
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={service.id} className={`service-card ${service.highlighted ? 'highlighted' : ''}`}>
              <div className="service-header">
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                {service.highlighted && (
                  <div className="featured-badge">
                    <i className="fas fa-star"></i>
                    <span>Popular</span>
                  </div>
                )}
              </div>

              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <div className="service-meta">
                  <div className="meta-item">
                    <i className="fas fa-layer-group"></i>
                    <span>{service.complexity}</span>
                  </div>
                </div>

                <div className="service-features">
                  <h4>Key Features</h4>
                  <ul>
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <i className="fas fa-check"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="service-footer">
                <a
                  href="#contact"
                  className="service-cta"
                  onClick={() => handleCTAClick(`Get Quote - ${service.title}`)}
                >
                  <span>Get Quote</span>
                  <i className="fas fa-arrow-right"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="services-cta">
          <div className="cta-content">
            <div className="cta-badge">
              <i className="fas fa-rocket"></i>
              <span>Let's Build Together</span>
            </div>
            <h3>Transform Your Vision into Reality</h3>
            <p>Join 50+ businesses who've already scaled their digital presence with our innovative solutions. Ready to be next?</p>
            <div className="cta-buttons">
              <a
                href="#contact"
                className="btn btn-primary"
                onClick={() => handleCTAClick('Start Your Project')}
              >
                <i className="fas fa-rocket"></i>
                Start Your Project
              </a>
              {/* <a 
                href="#work" 
                className="btn btn-secondary"
                onClick={() => handleCTAClick('View Success Stories')}
              >
                <i className="fas fa-star"></i>
                View Success Stories
              </a> */}
            </div>
            <div className="cta-trust-indicators">
              <div className="trust-item">
                <i className="fas fa-shield-alt"></i>
                <span>100% Secure</span>
              </div>
              <div className="trust-item">
                <i className="fas fa-clock"></i>
                <span>24/7 Support</span>
              </div>
              <div className="trust-item">
                <i className="fas fa-award"></i>
                <span>Quality Guaranteed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 